import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
import { WiseConfig } from "../../../Shared/features/WiseConfig";
import { defaults } from "../shared/defaults";
import footerTop from "./footerTop";
import homeJumbo from "./jumbo";
import newsletterBlock from "./newsLetterForm";
export const collectionSearchUrl = (term)=>`${WiseConfig().BaseUrl}/wise-apps/opac/${WiseConfig().LibraryId}/catalog/search?qs=${term}`;
const searchPlaceholderImage = {
    src: '/bkw/images/bkw/logo.svg',
    alt: 'Logo Bibliotheek Kennemerwaard',
    width: "165",
    height: "60"
};
const bkw = {
    ...defaults,
    loginUrl: ()=>`${WiseConfig().BaseUrl}/wise-apps/opac/branch/${WiseConfig().LibraryId}/my-account/checkouts/physical-materials?directLogin=true`,
    logo: ()=>/*#__PURE__*/ _jsx("img", {
            width: "231",
            height: "83",
            src: "/bkw/images/bkw/logo.svg",
            alt: "Bibliotheek Kennemerwaard",
            "aria-hidden": "true"
        }),
    collectionSearchUrl,
    homeJumbo,
    footerTop,
    newsletterBlock,
    searchPlaceholderImage
};
export default bkw;
